import React, { useState } from 'react';
// import Fade from 'react-reveal/Fade';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import mapIcon from '../../../../shared/assets/images/map_pin.png'
import useWindowWidth from '../../../../shared/hooks/useWindowWidth';
import "./ShopGoogleMap.scss"

function ShopGoogleMap({ shop }) {
    const [showMap, setShowMap] = useState(false);
    const windowWidth = useWindowWidth();

    const lat = Number(shop.latitude);
    const lng = Number(shop.longitude);

    const GoogleMapStyle = [
        {
            featureType: "all",
            elementType: "labels.text.fill",
            stylers: [
                {
                    saturation: 36
                },
                {
                    color: "#333333"
                },
                {
                    lightness: 40
                }
            ]
        },
        {
            featureType: "all",
            elementType: "labels.text.stroke",
            stylers: [
                {
                    visibility: "on"
                },
                {
                    color: "#ffffff"
                },
                {
                    lightness: 16
                }
            ]
        },
        {
            featureType: "all",
            elementType: "labels.icon",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "administrative",
            elementType: "all",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#fefefe"
                },
                {
                    lightness: 20
                }
            ]
        },
        {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#fefefe"
                },
                {
                    lightness: 17
                },
                {
                    weight: 1.2
                }
            ]
        },
        {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [
                {
                    lightness: 20
                },
                {
                    color: "#ececec"
                }
            ]
        },
        {
            featureType: "landscape.man_made",
            elementType: "all",
            stylers: [
                {
                    visibility: "on"
                },
                {
                    color: "#f0f0ef"
                }
            ]
        },
        {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "on"
                },
                {
                    color: "#f0f0ef"
                }
            ]
        },
        {
            featureType: "landscape.man_made",
            elementType: "geometry.stroke",
            stylers: [
                {
                    visibility: "on"
                },
                {
                    color: "#d4d4d4"
                }
            ]
        },
        {
            featureType: "landscape.natural",
            elementType: "all",
            stylers: [
                {
                    visibility: "on"
                },
                {
                    color: "#ececec"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "all",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
                {
                    lightness: 21
                },
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "on"
                },
                {
                    color: "#d4d4d4"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#303030"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "labels.icon",
            stylers: [
                {
                    saturation: "-100"
                }
            ]
        },
        {
            featureType: "poi.attraction",
            elementType: "all",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "poi.business",
            elementType: "all",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "poi.government",
            elementType: "all",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "poi.medical",
            elementType: "all",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "poi.park",
            elementType: "all",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
                {
                    color: "#dedede"
                },
                {
                    lightness: 21
                }
            ]
        },
        {
            featureType: "poi.place_of_worship",
            elementType: "all",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "poi.school",
            elementType: "all",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "poi.school",
            elementType: "geometry.stroke",
            stylers: [
                {
                    lightness: "-61"
                },
                {
                    gamma: "0.00"
                },
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi.sports_complex",
            elementType: "all",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#ffffff"
                },
                {
                    lightness: 17
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#ffffff"
                },
                {
                    lightness: 29
                },
                {
                    weight: 0.2
                }
            ]
        },
        {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
                {
                    color: "#ffffff"
                },
                {
                    lightness: 18
                }
            ]
        },
        {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [
                {
                    color: "#ffffff"
                },
                {
                    lightness: 16
                }
            ]
        },
        {
            featureType: "transit",
            elementType: "geometry",
            stylers: [
                {
                    color: "#f2f2f2"
                },
                {
                    lightness: 19
                }
            ]
        },
        {
            featureType: "water",
            elementType: "geometry",
            stylers: [
                {
                    color: "#dadada"
                },
                {
                    lightness: 17
                }
            ]
        }
    ];

    const MapComponent = withScriptjs(
        withGoogleMap(shop => (
            <GoogleMap
                defaultZoom={15}
                defaultCenter={
                    shop
                        ? { lat: lat, lng: lng }
                        : { lat: 40.29440491391765, lng: 69.6183030679822 }
                }
                defaultOptions={{
                    disableDefaultUI: true, // disable default map UI
                    draggable: true, // make map draggable
                    keyboardShortcuts: false, // disable keyboard shortcuts
                    scaleControl: true, // allow scale controle
                    scrollwheel: true, // allow scroll wheel
                    styles: GoogleMapStyle // change default map styles
                }}
            >
                <Marker position={shop
                    ? { lat: lat, lng: lng }
                    : { lat: 40.29440491391765, lng: 69.6183030679822 }
                }
                    icon={mapIcon}
                />
            </GoogleMap >
        ))
    );

    return (
        <div className="Shop">
            <div className="row">
                <div className="col-lg-6 col-sm-12 address-col">
                    {
                        windowWidth < 768 ?
                            <div className="mobile-google-map-content">
                                <button className="toogle-map-button" onClick={() => setShowMap(!showMap)}>
                                    <span className="toogle-map-button-text">{showMap ? "СКРЫТЬ КАРТУ" : "ПОКАЗАТЬ НА КАРТЕ"}</span>
                                    {
                                        showMap.showMap ?
                                            <svg
                                                width="12"
                                                height="12"
                                                viewBox="0 0 12 12"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M1.59375 4.88649L5.48285 0.99739M5.48285 0.99739L9.37194 4.88648M5.48285 0.99739L5.48322 12"
                                                    stroke="#39B980"
                                                    strokeWidth="1.2"
                                                />
                                            </svg> :
                                            <svg
                                                width="12"
                                                height="12"
                                                viewBox="0 0 12 12"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M1.59375 7.11351L5.48285 11.0026M5.48285 11.0026L9.37194 7.11352M5.48285 11.0026L5.48322 0"
                                                    stroke="#39B980"
                                                    strokeWidth="1.2"
                                                />
                                            </svg>
                                    }
                                </button>
                                {showMap && <MapComponent
                                    dushanbe
                                    isMarkerShown
                                    googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyA_KDeDoCTjEobgpOEA_M0pQPaVTtkz96g"
                                    loadingElement={
                                        <div style={{ height: `100%`, borderRadius: `8px !important` }} />
                                    }
                                    containerElement={
                                        <div style={{ height: `237px`, borderRadius: `8px !important` }} />
                                    }
                                    mapElement={
                                        <div style={{ height: `100%`, borderRadius: `8px !important` }} />
                                    }
                                ></MapComponent>}

                            </div> : <></>
                    }
                </div>

                <div className="col-lg-1 d-md-block d-sm-none"></div>

                {windowWidth > 767 ?
                    <div className="col-12 google-map">
                        <button className="toogle-map-button" onClick={() => setShowMap(!showMap)}>
                            <span className="toogle-map-button-text">{showMap ? "СКРЫТЬ КАРТУ" : "ПОКАЗАТЬ НА КАРТЕ"}</span>
                            {
                                showMap.showMap ?
                                    <svg
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.59375 4.88649L5.48285 0.99739M5.48285 0.99739L9.37194 4.88648M5.48285 0.99739L5.48322 12"
                                            stroke="#39B980"
                                            strokeWidth="1.2"
                                        />
                                    </svg> :
                                    <svg
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.59375 7.11351L5.48285 11.0026M5.48285 11.0026L9.37194 7.11352M5.48285 11.0026L5.48322 0"
                                            stroke="#39B980"
                                            strokeWidth="1.2"
                                        />
                                    </svg>
                            }
                        </button>

                        {showMap && <MapComponent
                            dushanbe
                            isMarkerShown
                            googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyA_KDeDoCTjEobgpOEA_M0pQPaVTtkz96g"
                            loadingElement={
                                <div style={{ height: `100%`, borderRadius: `8px !important` }} />
                            }
                            containerElement={
                                <div style={{ height: `237px`, borderRadius: `8px !important` }} />
                            }
                            mapElement={
                                <div style={{ height: `100%`, borderRadius: `8px !important` }} />
                            }
                        ></MapComponent>}
                    </div> : <></>
                }
            </div>
        </div>
    )
}

export default ShopGoogleMap;
